import CurrencyByCode from './currencyByCode.filter';
import HtmlUnsafe from './htmlUnsafe.filter';
import MomentDate from './momentDate.filter';
import Time from './time.filter';

const MODULE_NAME = 'App.Filters';
const module = angular
    .module(MODULE_NAME, [])
    .filter('currencyByCode', CurrencyByCode)
    .filter('htmlUnsafe', HtmlUnsafe)
    .filter('momentDate', MomentDate)
    .filter('time', Time);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/filters/filters-module.js